import commonUtils from './commonUtils';

// 常见正则
export const RuleRegExp = {
  number: /^[0-9]*$/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  phone: /^1[3-9]\d{9}$/,
  chinese: /[\u4e00-\u9fa5]/,
  password: /^[a-zA-Z0-9]{6,16}$/,
  float: /^(-?\d+)(\.\d+)?$/
};
// 数据验证器
export default class Validator {
  // 是否为空，用于必填项判断
  static required(val: string | number | any[]): boolean {
    if (val === undefined || val === null) {
      return false;
    }
    if (Array.isArray(val) && !val.length) {
      return false;
    }
    if (!val.toString().trim()) {
      return false;
    }
    return true;
  }

  // 最大值判断，number 最大数值
  static maxNum(val: string, maxNum: number, noMax?: boolean): boolean {
    if (!noMax) {
      return !(Number(val) > maxNum);
    }
    return Number(val) < maxNum;
  }

  // 最小值判断，number 最小数值
  static minNum(val: string, minNum: number, noMin?: boolean): boolean {
    if (!noMin) {
      return !(Number(val) < minNum);
    }
    return Number(val) > minNum;
  }

  // 长度限制判断，tring 和 array 类型 最大长度
  static maxLen(val: string, maxLen: number): boolean {
    return !(val.length > maxLen);
  }

  // 正整数数字验证
  static number(num: number | string): boolean {
    const pattern = RuleRegExp.number;
    return pattern.test(num.toString());
  }

  // 浮点数验证
  static float(num: number | string): boolean {
    const pattern = RuleRegExp.float;
    return pattern.test(num.toString());
  }

  // 邮箱格式验证
  static email(email: string): boolean {
    const pattern = RuleRegExp.email;
    return pattern.test(email.toLowerCase());
  }

  // 手机号码验证
  static phone(phone: string): boolean {
    const pattern = RuleRegExp.phone;
    return pattern.test(phone);
  }

  // 网址验证
  static url(url: string) {
    const pattern = RuleRegExp.url;
    pattern.lastIndex = 0;
    return pattern.test(url.toLowerCase());
  }

  // 中文验证
  static chinese(char: string): boolean {
    const pattern = RuleRegExp.chinese;
    return pattern.test(char);
  }

  // 密码验证
  static password(pw: string): boolean {
    const pattern = RuleRegExp.password;
    return pattern.test(pw);
  }

  // 自定义正则验证
  static pattern(val: string, pattern: RegExp): boolean {
    return pattern.test(val);
  }
}
export interface IRuleConfig {
  required?: boolean;
  message?: string;
  pattern?: RegExp;
  type?:
    | 'number'
    | 'email'
    | 'url'
    | 'phone'
    | 'chinese'
    | 'password'
    | 'float';
  maxNum?: number; // number 最大数值
  minNum?: number;
  maxLen?: number; // string 和 array 类型 最大长度
  noMax?: boolean;
  noMin?: boolean;
  validator?: (val: any) => { pass: boolean; message?: string };
}
export interface IResult {
  pass: boolean;
  msg?: string;
}

export const defaultResult: IResult = { pass: true };

export function validatorWithMsg(value: any, rules?: IRuleConfig[]) {
  let result: any = commonUtils.deep(defaultResult);
  if (Array.isArray(rules) && rules.length) {
    rules.every(rule => {
      const { validator } = rule;
      if (!validator) {
        // 常规验证
        const pass = validatorCore(value, rule);
        if (!pass) {
          result = { pass, msg: rule.message || defaultMsgCenter(rule) };
        }
        return pass;
      } else {
        // 自定义验证
        const { pass, message } = validator(value);
        if (!pass) {
          result = { pass, msg: message || defaultMsgCenter(rule) };
        }
        return pass;
      }
    });
    return result;
  }
  return result;
}

function validatorCore(value: any, rule: IRuleConfig) {
  const {
    required,
    type,
    pattern,
    maxNum,
    minNum,
    maxLen,
    noMax,
    noMin
  } = rule;
  if (required) {
    return Validator.required(value);
  } else {
    if (!Validator.required(value)) {
      return true;
    }
    if (maxLen) {
      return Validator.maxLen(value, maxLen);
    } else if (type) {
      return Validator[type].call(window, value);
    } else if (pattern) {
      return Validator.pattern(value, pattern);
    } else if (maxNum !== undefined) {
      return Validator.maxNum(value, maxNum, noMax);
    } else if (minNum !== undefined) {
      return Validator.minNum(value, minNum, noMin);
    } else {
      return true;
    }
  }
}

function defaultMsgCenter(rule: IRuleConfig) {
  const {
    required,
    type,
    pattern,
    maxNum,
    minNum,
    maxLen,
    noMax,
    noMin
  } = rule;
  if (required) {
    return '不能为空';
  } else if (maxLen) {
    return '不得超过' + maxLen + '个字符';
  } else if (type) {
    return '格式错误';
  } else if (pattern) {
    return '格式错误';
  } else if (maxNum !== undefined) {
    if (noMax) {
      return '必须小于' + maxNum;
    }
    return '不得大于' + maxNum;
  } else if (minNum !== undefined) {
    if (noMin) {
      return '必须大于' + minNum;
    }
    return '不得小于' + minNum;
  } else {
    return '格式错误';
  }
}

export function isPass(field: any) {
  if (!field || !field.validatorValue().pass) {
    return false;
  }
  return true;
}

export function isPassList(fields: any[]): boolean {
  for (let i = 0; i < fields.length; i++) {
    if (!isPass(fields[i])) {
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Validator.ts